import React from 'react'
import { Skeleton } from './ui/skeleton'

const FiltersSkeleton = () => {
  return (
    <div>
      <h6 className="font-bold text-sm mb-2">Filters</h6>

      <div className="flex mb-4">

        <div className="space-y-1 w-[300px] mr-2">
          <Skeleton className="h-10 w-[300px]"/>
        </div>

      </div>

    </div>
  )
}

export default FiltersSkeleton